module.exports = __webpack_public_path__ + "img/3.31d7ecb5.jpg";